<template>
<!-- This example requires Tailwind CSS v2.0+ -->
<div class="fixed z-10 inset-0 overflow-y-auto" :class="showModal?'':'hidden'" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <div class="inline-block align-bottom bg-gray-700 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-700px w-full">

    <section class="p-3 border-b border-gray-800">
      <div class="flex justify-between">
        <div class="flex">
          <h4 class="text-white text-sm font-bold uppercase mb-3">Edit Provider</h4>
          <span v-if="$page.props.flash.pop_up_message" class="ml-5 mt-2 text-green-700">{{ $page.props.flash.pop_up_message }}</span>
        </div>
        <button type="button" class="close" @click.prevent="toggleModal"><span>×</span></button>
      </div>
    </section>

    <div class="flex lang-box pt-2">
        <a v-for="(lang, index) in languages" href="#" @click.prevent="changeLanguage(lang)" :key="index"
        :class="{active:(form.current_language == lang)}">{{ lang }}</a>
    </div>

    <section>
      <div class="flex p-2">
        <div class="w-1/3 p-2 border-gray-800 border-r">
          <label for="">Logo</label>
          <RecommendedAspectRatio uploadBoxType="provider-logo" />
            <div v-if="form.logo_file.loaded_file_path == null" class="upload-box">
                <span>
                  <i class="icon-upload mr-2"></i>
                  <a @click.prevent="changeUploadBoxState('providers_logo')" href="##">Upload from media library</a>
              </span>
            </div>

            <div v-if="form.logo_file.loaded_file_path" class="upload-box relative">
                <div class="">
                    <img :src="form.logo_file.loaded_file_path" class="logo-img">
                </div>

                <div class="badge-buttons-wrapper">
                  <div class="badge-buttons shadow">
                      <button @click.prevent="() => changeUploadBoxState('providers_logo')"
                      title="Edit"><i class="pen"></i></button>
                      <button @click.prevent="() => deleteProvidersLogo(providerIdentifier)"
                      title="Delete"><i class="trash"></i></button>
                  </div>
              </div>
            </div>

        </div>

        <div class="w-2/3 p-2">
          <label for="name">Provider name</label>
          <input id="name" type="text" class="input-black" @change="handleChange"
          :value="getCurrentInputForName()">

          <div class="grid grid-cols-2 gap-2">

            <div>
              <label for="coutry_code">Country</label>
              <select id="coutry_code" class="select-black" v-model="form.country_code">
                  <option value=""></option>
                  <option value="DE">DE</option>
                  <option value="US">US</option>
                  <option value="IT">IT</option>
                  <option value="BR">BR</option>
              </select>
            </div>
            <div>
              <label for="postal_code">Postal code</label>
              <input id="postal_code" type="text" class="input-black" v-model="form.postal_code">
            </div>

          </div>


          <label for="city">City</label>
          <input id="city" type="text" class="input-black" @change="handleChange"
          :value="getCurrentInputForCity()">

          <label for="street">Street</label>
          <input id="street" type="text" class="input-black" @change="handleChange"
          :value="getCurrentInputForStreet()">

          <label>Infos</label>
          <input v-for="info in form.infos" class="input-black provider-info" type="text"
          @change="handleChange" :value="getCurrentInputForInfo(info.id)" :data-id="info.id">

          <button @click.prevent="addInfo" class="btn btn-black btn-sm btn-w-icon mr-2">Add info</button>
          <button @click.prevent="removeLastInfo" class="btn btn-black btn-sm btn-w-icon">Remove last info</button>

          <button v-if="!form.processing" @click="updateProvider" class="btn btn-gradient mt-2 mb-2 float-right">
              <i class="save mr-2"></i>Update
          </button>
          <button v-else class="btn btn-gradient btnpx-10 mt-2 mb-2 float-right"><Spinner/></button>

        </div>
      </div>
    </section>

    <Team
    :toggleModal="toggleModal"
    :provider_id="provider_id" />

    <AssociatedTours
    :provider="current_provider" />

    </div>
  </div>
</div>

<MediaLibrary
:uploadBoxState="uploadBoxState"
:changeUploadBoxState="changeUploadBoxState"
:select="selectFileFromMediaLibrary"
:provider_id="provider_id"
/>

</template>

<script>
import Team from './Team'
import AssociatedTours from './AssociatedTours'
import {
  changeUploadBoxState,
  selectFileFromMediaLibrary
} from '@/Pages/Media/MediaLibraryLogic.js'
import MediaLibrary from '@/Pages/Media/MediaLibrary'
import { deleteProvidersLogo } from '@/Pages/GlobalHelpers'
import RecommendedAspectRatio from '@/Pages/Media/RecommendedAspectRatio'
import Spinner from '@/UI/Spinner'

export default {
  props: ['showModal', 'toggleModal', 'provider_id'],
  components: {
    Team,
    AssociatedTours,
    MediaLibrary,
    RecommendedAspectRatio,
    Spinner
  },
  data(){
    return{
      languages: this.$page.props.languages,
      current_provider: null,
      providerIdentifier: null,
      form: this.$inertia.form({
          _method: 'POST',
          providerNames: [],
          infos: [],
          country_code: null,
          postal_code: null,
          providerCities: [],
          providerStreet: [],
          current_language: null,
          logo_file: {
            loaded_file_path: null,
            from_media_library_id: false,
          }
      }),
      remove_info_form: this.$inertia.form({
          _method: 'POST',
          info_id: null,
      }),
      delete_providers_logo_form: this.$inertia.form({
        _method: 'DELETE'
      }),
      uploadBoxState: null,
    }
  },
  watch:{
    provider_id:function( newState, oldState ){
      this.providerIdentifier = (newState != null) ? this.$page.props.providers.data
      .filter(el => el.id == newState)[0].identifier : null;
      if(this.$page.props.providers.data.filter(el => el.id == newState).length)
      {
        this.updateProvidersData(newState);
      } else {
        this.current_provider = null;
        this.form.providerNames = [];
        this.form.infos = [];
        this.form.providerCities = [];
        this.form.providerStreet = [];
        this.form.logo_file.loaded_file_path = null;
      }
    }
  },
  methods: {
    changeLanguage(lang){
      this.form.current_language = lang;
    },
    updateProvider(){
      this.form.post(route('provider.update', this.providerIdentifier), {
        onSuccess: () => {
          this.updateProvidersData(this.provider_id)
        },
        onError: (err) => {}
      });
    },
    makeProviderNames(){
      //set up name for the provider
      const nameLocalized = this.current_provider &&
      this.current_provider.name_localized.localized_text;
      let arr = [];
      this.$page.props.languages.map(lang => {
        arr.push({
          lang: lang,
          name: nameLocalized ? nameLocalized[lang] : null
        });
      })
      return arr;
    },
    makeProviderInfos(){
      const infosLocalized = this.current_provider && this.current_provider.infos;
      if(infosLocalized)
      {
        const infoResources = infosLocalized.filter(el => el.type == 'text');

        let providerInfos = [];
        infoResources.forEach(el => {
          providerInfos.push({
            id: el.id,
            values: el.value_all_languages.localized_text
          })
        })

        return providerInfos;
      }

      return []
    },
    makeProviderCities(){
      //set up city for the provider in different languages
      const cityLocalized = this.current_provider && this.current_provider.city_localized_text &&
      this.current_provider.city_localized_text.localized_text;
      let arr = [];
      this.$page.props.languages.map(lang => {
        arr.push({
          lang: lang,
          name: cityLocalized ? cityLocalized[lang] : null
        });
      })
      return arr;
    },
    makeProviderStreet(){
      //set up street for the provider in different languages
      const streetLocalized = this.current_provider && this.current_provider.street_localized_text &&
      this.current_provider.street_localized_text.localized_text;
      let arr = [];
      this.$page.props.languages.map(lang => {
        arr.push({
          lang: lang,
          name: streetLocalized ? streetLocalized[lang] : null
        });
      })
      return arr;
    },
    getCurrentInputForName(){
      return this.form.providerNames.filter(el => el.lang == this.form.current_language).length &&
      this.form.providerNames.filter(el => el.lang == this.form.current_language)[0].name
    },
    getCurrentInputForCity(){
      return this.form.providerCities.filter(el => el.lang == this.form.current_language).length &&
      this.form.providerCities.filter(el => el.lang == this.form.current_language)[0].name
    },
    getCurrentInputForStreet(){
      return this.form.providerStreet.filter(el => el.lang == this.form.current_language).length &&
      this.form.providerStreet.filter(el => el.lang == this.form.current_language)[0].name
    },
    getCurrentInputForInfo(infoId){
      return this.form.infos.filter(el => el.id == infoId)[0]
      .values[this.form.current_language]
    },
    handleChange(e){
      if(e.target.id == 'name')
      {
        this.form.providerNames.filter(el => el.lang == this.form.current_language)[0].name = e.target.value;
      }
      if(e.target.id == 'city')
      {
        this.form.providerCities.filter(el => el.lang == this.form.current_language)[0].name = e.target.value;
      }
      if(e.target.id == 'street')
      {
        this.form.providerStreet.filter(el => el.lang == this.form.current_language)[0].name = e.target.value;
      }
      // provider infos handle change
      if(Array.from(e.target.classList).includes('provider-info'))
      {
        const infoId = e.target.getAttribute('data-id');
        this.form.infos.filter(el => el.id == infoId)[0]
        .values[this.form.current_language] = e.target.value;
      }
    },
    addInfo() {
      if(this.form.infos.filter(el => el.id == null).length)
      {
        return;
      }
      this.form.infos.push({
          id: null,
          values: {}
      })
    },
    removeLastInfo() {
      const id = this.form.infos.slice(-1)[0].id;
      if(id){
          this.remove_info_form.info_id = id;
          this.remove_info_form.post(route('provider-info.delete', this.remove_info_form.info_id), {
          onSuccess: () => {
            //this.toggleModal();
          },
          onError: (err) => {
            //this.toggleModal();
          }
        });
      }
      this.form.infos.pop();
    },
    changeUploadBoxState: changeUploadBoxState,
    selectFileFromMediaLibrary: selectFileFromMediaLibrary,
    deleteProvidersLogo: deleteProvidersLogo,
    updateProvidersData(newState) {
      this.current_provider = this.$page.props.providers.data.filter(el => el.id == newState)[0];
      this.form.providerNames = this.makeProviderNames();
      this.form.infos = this.makeProviderInfos();
      this.form.country_code = this.current_provider && this.current_provider.country_code;
      this.form.postal_code = this.current_provider && this.current_provider.postal_code;
      this.form.providerCities = this.makeProviderCities();
      this.form.providerStreet = this.makeProviderStreet();
      this.form.logo_file.loaded_file_path = this.current_provider.logo;
    }
  },
  mounted(){
    this.changeLanguage(this.$page.props.languages[0])
  }
}
</script>